var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnFilterCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.99988C11.875 3.8749 11.7054 3.80469 11.5287 3.80469C11.3519 3.80469 11.1823 3.8749 11.0573 3.99988L7.99999 7.05721L4.94265 3.99988C4.81763 3.8749 4.64809 3.80469 4.47132 3.80469C4.29454 3.80469 4.125 3.8749 3.99999 3.99988C3.875 4.1249 3.80479 4.29444 3.80479 4.47121C3.80479 4.64799 3.875 4.81753 3.99999 4.94255L7.05732 7.99988L3.99999 11.0572C3.875 11.1822 3.80479 11.3518 3.80479 11.5285C3.80479 11.7053 3.875 11.8749 3.99999 11.9999C4.125 12.1249 4.29454 12.1951 4.47132 12.1951C4.64809 12.1951 4.81763 12.1249 4.94265 11.9999L7.99999 8.94254L11.0573 11.9999C11.1823 12.1249 11.3519 12.1951 11.5287 12.1951C11.7054 12.1951 11.875 12.1249 12 11.9999C12.125 11.8749 12.1952 11.7053 12.1952 11.5285C12.1952 11.3518 12.125 11.1822 12 11.0572L8.94265 7.99988L12 4.94255C12.125 4.81753 12.1952 4.64799 12.1952 4.47121C12.1952 4.29444 12.125 4.1249 12 3.99988Z",
    fill: "#0090D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFilterCloseX);
export default __webpack_public_path__ + "static/media/btn_filter_closeX.f00ed9876c1d3a880c2cc9c95e9d2a17.svg";
export { ForwardRef as ReactComponent };